export default __webpack_public_path__ + "static/9-13affaeb1a6bd14d588f026d98154b29.png";